<template>
    <modal :show.sync="show" modalClasses="modal-hide-footer" size="lg">
      <h3 slot="header" class="mb-0">CCRIS DERIVATIVES</h3>
      <b-row>
        <b-col cols="12">
          <h4 style="margin-bottom: 10px">CCRIS DERIVATIVES</h4>
          
          <div class="table-container">
            <table class="ccris-derivatives-table bordered summary-table" style="width: 100%">
              <tbody>
                <tr class="section-header">
                  <td style="width: 50%"><strong>Earliest known facility:</strong></td>
                  <td style="width: 50%"></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Date of application:</td>
                  <td>{{ formatDate(reportData.app_date) || '-' }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Facility type:</td>
                  <td>{{ formatFacilityType(reportData.app_facility_code, reportData.app_facility_name) || '-' }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>Secured facilities:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;"># of facilities</td>
                  <td class="text-right">{{ reportData.fac_sec_total || '0' | fixNumberFormat }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Total outstanding balance (RM)</td>
                  <td class="text-right">{{ formatCurrency(reportData.fac_sec_out_balance) }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Total outstanding as % of total limit</td>
                  <td class="text-right">{{ formatPercentage(reportData.fac_sec_out_limit) }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Average number of installments in arrears</td>
                  <td class="text-right">{{ formatNumber(reportData.fac_sec_out_average) }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>Unsecured facilities:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;"># of facilities</td>
                  <td class="text-right">{{ reportData.fac_unsec_total || '0' | fixNumberFormat }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Total outstanding balance (RM)</td>
                  <td class="text-right">{{ formatCurrency(reportData.fac_unsec_out_balance) }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Total outstanding as % of total limit</td>
                  <td class="text-right">{{ formatPercentage(reportData.fac_unsec_out_limit) }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Average number of installments in arrears</td>
                  <td class="text-right">{{ formatNumber(reportData.fac_unsec_out_average) }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>Credit Card:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Average Utilisation Last 6 Months</td>
                  <td class="text-right">{{ formatPercentage(summaryData.credit_card_utilization) }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>Other Revolving Credits:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Average Utilisation Last 6 Months</td>
                  <td class="text-right">{{ formatPercentage(summaryData.other_revolving_utilization) }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>Charge Card:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Min Utilisation Last 12 Months (RM)</td>
                  <td class="text-right">{{ formatCurrency(chargeCardMin) }}</td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Max Utilisation Last 12 Months (RM)</td>
                  <td class="text-right">{{ formatCurrency(chargeCardMax) }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>PTPTN:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Number of Accounts</td>
                  <td class="text-right">{{ reportData.ptptn_accounts || '0' | fixNumberFormat }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>Local Lenders:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Number of Accounts</td>
                  <td class="text-right">{{ localLendersCount || '0' | fixNumberFormat }}</td>
                </tr>
  
                <tr class="section-header">
                  <td><strong>Foreign Lenders:</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td style="padding-left: 20px;">Number of Accounts</td>
                  <td class="text-right">{{ foreignLendersCount || '0' | fixNumberFormat }}</td>
                </tr>
              </tbody>
            </table>
          </div>
  
        </b-col>
      </b-row>
    </modal>
  </template>
  
  <script>
  import Modal from "@/components/Modal";
  
  export default {
    name: "CcrisDerivativesModal",
    props: {
      ccrisDerivatives: {
        type: Object,
        default: () => ({})
      },
      show_ccris_derivatives_full_view: Boolean,
      customerId: {
        type: [String, Number],
        default: null
      },
      reportDataCcrisDerivatives: {
        type: Object,
        default: () => ({})
      }
    },
    components: {
      Modal,
    },
    computed: {
      show: {
        get() {
          return this.show_ccris_derivatives_full_view;
        },
        set(value) {
          this.$emit("update:show_ccris_derivatives_full_view", value);
        },
      },
      summaryData() {
        return this.ccrisDerivatives || {};
      },
      reportData() {
        return this.reportDataCcrisDerivatives && Object.keys(this.reportDataCcrisDerivatives).length > 0
          ? this.reportDataCcrisDerivatives
          : (this.ccrisDerivatives && this.ccrisDerivatives.report_data) || this.ccrisDerivatives || {};
      },
      chargeCardMin() {
        return this.reportData.charge_card_utilization && this.reportData.charge_card_utilization.min_12_months;
      },
      chargeCardMax() {
        return this.reportData.charge_card_utilization && this.reportData.charge_card_utilization.max_12_months;
      },
      localLendersCount() {
        return this.reportData.lender_distribution && this.reportData.lender_distribution.local_lenders;
      },
      foreignLendersCount() {
        return this.reportData.lender_distribution && this.reportData.lender_distribution.foreign_lenders;
      }
    },
    methods: {
      formatDate(dateString) {
        if (!dateString) return '-';
        
        try {
          if (typeof dateString === 'string' && dateString.includes('-')) {
            const parts = dateString.split('-');
            
            if (parts.length === 3 && parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
              return dateString;
            }
            
            if (parts.length === 3 && parts[0].length === 4 && parts[1].length === 2 && parts[2].length === 2) {
              return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
          }
          
          const date = new Date(dateString);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            }).replace(/\//g, '-');
          }
          
          return dateString;
        } catch (e) {
          return dateString;
        }
      },
      formatFacilityType(code, name) {
        if (!code && !name) return '-';
        if (code && name) return `${code} - ${name}`;
        return code || name || '-';
      },
      formatPercentage(value) {
        if (value === null || value === undefined || value === '') {
          return '0.00%';
        }
        const num = parseFloat(value);
        if (isNaN(num)) return '0.00%';
        return num.toFixed(2) + '%';
      },
      formatCurrency(value) {
        if (value === null || value === undefined || value === '' || value === 0) {
          return 'RM 0.00';
        }
        const num = parseFloat(value);
        if (isNaN(num)) return 'RM 0.00';
        return 'RM ' + num.toLocaleString('en-MY', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      },
      formatNumber(value) {
        if (value === null || value === undefined || value === '') {
          return '-';
        }
        const num = parseFloat(value);
        if (isNaN(num)) return '-';
        return num.toFixed(1);
      }
    },
  };
  </script>
  
  <style scoped>
  .ccris-derivatives-table {
    border-collapse: collapse;
    width: 100%;
    font-family: inherit;
    margin-bottom: 0;
  }
  
  .ccris-derivatives-table.bordered,
  .ccris-derivatives-table th,
  .ccris-derivatives-table td {
    border: 1px solid #000 !important;
  }
  
  .section-header td {
    background-color: #252938 !important;
    color: #fff !important;
    font-weight: 600;
    padding: 9px 12px !important;
    border: 1px solid #000 !important;
  }
  
  .ccris-derivatives-table td {
    background-color: #fff !important;
    color: #000 !important;
    padding: 8px 6px;
    text-align: left;
    border: 1px solid #000 !important;
  }
  
  .ccris-derivatives-table .text-right {
    text-align: right !important;
  }
  
  .table-container {
    width: 100%;
    overflow-x: auto;
  }
  
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .table-container {
      font-size: 0.7rem;
    }
    
    .ccris-derivatives-table th,
    .ccris-derivatives-table td {
      padding: 6px 4px;
    }
    
    h4 {
      font-size: 16px;
    }
  }
  </style>
  